var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTutorMode = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 57,
  height: 56,
  fill: "none",
  viewBox: "0 0 56 57"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Tutor-Mode_svg__a)",
  d: "m12.422 32.282.173 1.051a3.987 3.987 0 0 0 4.582 3.286l27.612-4.55a3.987 3.987 0 0 0 3.286-4.582l-.173-1.052-35.48 5.847Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Tutor-Mode_svg__b)",
  d: "m9.499 14.541 35.48-5.846 2.102 12.754-35.48 5.846-2.102-12.754Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Tutor-Mode_svg__c)",
  d: "m51.828 4.01.94 5.7a2.519 2.519 0 0 1-2.075 2.893l-4.937.814 2.319 14.071a3.988 3.988 0 0 1-3.285 4.581l-20.3 3.345-4.503-3.229L15.899 7.38l33.036-5.443a2.519 2.519 0 0 1 2.893 2.074Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Tutor-Mode_svg__d)",
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "m44.627 31.082-27.612 4.55a2.987 2.987 0 0 1-3.433-2.462l-2.934-17.805 33.507-5.52 2.934 17.804a2.987 2.987 0 0 1-2.462 3.433Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Tutor-Mode_svg__e)",
  d: "M24.112 23.488c.401 2.433-.61 8.596-3.043 8.996-2.433.401-5.368-5.111-5.769-7.545a4.466 4.466 0 0 1 8.812-1.451Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Tutor-Mode_svg__f)",
  d: "m50.693 12.603-11.338 1.868-11.338 1.869-11.338 1.868L5.34 20.076a2.518 2.518 0 0 1-2.893-2.075l-.939-5.699A2.518 2.518 0 0 1 3.583 9.41l45.353-7.473a2.518 2.518 0 0 1 2.893 2.075l.94 5.698a2.517 2.517 0 0 1-2.076 2.894Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "m43.804 13.738 6.89-1.135a2.517 2.517 0 0 0 2.074-2.894L51.83 4.01a2.518 2.518 0 0 0-2.893-2.074L3.583 9.409a2.518 2.518 0 0 0-2.075 2.893l.939 5.699a2.518 2.518 0 0 0 2.893 2.075l6.89-1.135"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#Tutor-Mode_svg__g)",
  d: "m15.223 7.843 3 18.203a1.763 1.763 0 0 0 3.478-.573L18.69 7.197a1.763 1.763 0 0 0-2.08-1.443c-.946.186-1.543 1.137-1.387 2.09Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "Tutor-Mode_svg__a",
  x1: 30.459,
  x2: 30.826,
  y1: 31.162,
  y2: 33.386,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4600EA",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4600EA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Tutor-Mode_svg__b",
  x1: 28.787,
  x2: 28.098,
  y1: 21.01,
  y2: 16.829,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4600EA",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#261E84"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Tutor-Mode_svg__c",
  x1: 40.447,
  x2: 18.402,
  y1: 18.059,
  y2: 21.692,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4600EA",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4600EA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Tutor-Mode_svg__d",
  x1: 27.372,
  x2: 35.162,
  y1: 23.268,
  y2: 21.984,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B765DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9324FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Tutor-Mode_svg__e",
  x1: 15.123,
  x2: 24.555,
  y1: 26.953,
  y2: 25.399,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEE45A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEA613"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Tutor-Mode_svg__f",
  x1: 26.895,
  x2: 27.68,
  y1: 9.531,
  y2: 14.291,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5C0FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8249FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Tutor-Mode_svg__g",
  x1: 16.521,
  x2: 20.245,
  y1: 16.94,
  y2: 16.327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEE45A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEA613"
})))));
export { SvgTutorMode as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZWI5ZTg2NGUyNDA1ZTQ4YzA2YzgwNjllOTVlMmQzMjguc3ZnIjs=";